<app-main-layout>
  <app-team-form-page></app-team-form-page>
</app-main-layout>
